import { NextPage, NextPageContext } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import { newsBg } from 'images/news';
import { NewsPageWrapper } from 'containers/news';
import services from 'services';
import { NewsPostList, NewsSinglePost } from 'services/news/types';
import { Metadata } from 'containers/common';
import { PageNotFound } from 'containers/errors';

interface SinglePostPage {
  post: NewsSinglePost | null;
}

export interface NewsProps extends SinglePostPage {
  relatedPosts: Array<NewsSinglePost>;
}

const News: NextPage<NewsProps> = (props) => {
  const { post, relatedPosts } = props;
  if (!post) {
    return <PageNotFound />;
  }
  return (
    <>
      <Metadata propDescription={post.meta_description} propTitle={post.meta_title} />
      <Header
        title="News"
        description="We don’t expect success, we work for it. Become a part of an amazing team!"
        image={newsBg}
      />
      <NewsPageWrapper data={post} relatedPosts={relatedPosts} />
    </>
  );
};

export const getServerSideProps = async (ctx: NextPageContext): Promise<unknown> => {
  const { id } = ctx.query;
  const { newsService } = services;
  let post: NewsSinglePost | null = null;
  let relatedPosts: Array<NewsPostList> = [];
  try {
    post = await newsService.getOnePost(String(id));
    try {
      relatedPosts = await newsService.getRelatedPosts(post.id);
    } catch (e) {
      console.log(e);
    }
  } catch (e) {
    console.log(e);
  }
  return {
    props: { post, relatedPosts },
  };
};

export default News;
